(function(){"use strict";var BANDS=["$500 \u2013 $2,499","$2,500+","$2,500+","$2,500+","$2,500+","$2,500+","$2,500+"],DATA={US:{cur:"$",curNote:"USD",unit:"state",zoneOf:{WA:"Home",OR:"Home",ID:"Home",MT:"Near",NV:"Near",UT:"Near",WY:"Near",CA:"Near",AZ:"Far",CO:"Far",NM:"Far",TX:"Furthest",OK:"Furthest"},zones:{Home:{label:"Zone 1 — Home",covers:"Washington · Oregon · Idaho",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Near:{label:"Zone 2 — Near",covers:"Montana · Nevada · Utah · Wyoming · California",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Far:{label:"Zone 3 — Far",covers:"Arizona · Colorado · New Mexico",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Furthest:{label:"Zone 4 — Furthest",covers:"Texas · Oklahoma",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]}},lt:{WA:[14,42,14,42],OR:[14,42,14,42],ID:[14,42,14,42],MT:[14,42,14,42],NV:[14,42,14,42],UT:[14,42,14,42],WY:[14,42,14,42],CA:[14,42,14,42],AZ:[14,42,14,42],CO:[14,42,14,42],NM:[14,42,14,42],TX:[14,42,14,42],OK:[14,42,14,42]},paused:{NE:["Q4 2027","Arizona"],ND:["Q4 2027","Arizona"],SD:["Q4 2027","Arizona"],IL:["Q4 2027","Arizona"],MO:["Q4 2027","Arizona"],IA:["Q4 2027","Arizona"],LA:["Q4 2027","Arizona"],MN:["Q4 2027","Arizona"],WI:["Q4 2027","Arizona"],KS:["Q4 2027","Arizona"],MS:["Q1 2028","Georgia"],GA:["Q1 2028","Georgia"],FL:["Q1 2028","Georgia"],TN:["Q1 2028","Georgia"],KY:["Q1 2028","Georgia"],SC:["Q1 2028","Georgia"],NC:["Q1 2028","Georgia"],VA:["Q2 2028","Pennsylvania"],WV:["Q2 2028","Pennsylvania"],MD:["Q2 2028","Pennsylvania"],DC:["Q2 2028","Pennsylvania"],DE:["Q2 2028","Pennsylvania"],NJ:["Q2 2028","Pennsylvania"],PA:["Q2 2028","Pennsylvania"],NY:["Q2 2028","Pennsylvania"],CT:["Q2 2028","Pennsylvania"],MA:["Q2 2028","Pennsylvania"],VT:["Q2 2028","Pennsylvania"],NH:["Q2 2028","Pennsylvania"],ME:["Q2 2028","Pennsylvania"],RI:["Q2 2028","Pennsylvania"],MI:["Q2 2028","Pennsylvania"],OH:["Q2 2028","Pennsylvania"],IN:["Q2 2028","Pennsylvania"]},none:{AL:1,AR:1,AK:1,HI:1},names:{AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",CT:"Connecticut",DE:"Delaware",DC:"Washington DC",FL:"Florida",GA:"Georgia",HI:"Hawaii",ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming"}},CA:{cur:"$",curNote:"CAD",unit:"province",zoneOf:{BC:"Home",AB:"Near",SK:"Far",MB:"Furthest",ON:"Furthest"},zones:{Home:{label:"Zone 1 — Home",covers:"British Columbia",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Near:{label:"Zone 2 — Near",covers:"Alberta",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Far:{label:"Zone 3 — Far",covers:"Saskatchewan",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]},Furthest:{label:"Zone 4 — Furthest",covers:"Manitoba",loose:[99,0,0,0,0,0,0],crane:[99,0,0,0,0,0,0]}},lt:{BC:[14,42,14,42],AB:[14,42,14,42],SK:[14,42,14,42],MB:[14,42,14,42],ON:[14,42,14,42]},paused:{},none:{QC:1,NB:1,NS:1,PE:1,YT:1,NT:1,NU:1,NL:1},names:{BC:"British Columbia",AB:"Alberta",SK:"Saskatchewan",MB:"Manitoba",ON:"Ontario",QC:"Quebec",NB:"New Brunswick",NS:"Nova Scotia",PE:"Prince Edward Island",NL:"Newfoundland & Labrador",YT:"Yukon",NT:"Northwest Territories",NU:"Nunavut"}}},root=document.getElementById("bb-freight-finder");if(!root)return;var C=DATA[window.BB_FF_COUNTRY==="CA"?"CA":"US"];/* ⛔ COVERAGE DATA FOR THE MAP BELOW THE TABLE. A served LIST, not zoneOf — zone names are
   ROUTE information and are never handed to a customer. served = zoneOf minus paused minus none,
   because the documented way to pause a region is to KEEP it in the zone map and list it
   separately, so zoneOf keys are not by themselves the served set. */
try{(function(){var sv=[],k;for(k in C.zoneOf){if(!(C.paused&&C.paused[k])&&!(C.none&&C.none[k]))sv.push(k)}
var nn=[];for(k in (C.none||{}))nn.push(k);
window.BB_COVERAGE={served:sv,paused:C.paused||{},none:nn,names:C.names||{},country:(window.BB_FF_COUNTRY==="CA"?"CA":"US"),unit:C.unit||"state"};})()}catch(e){}var BANDSC=BANDS.map(function(b){return b.replace(/\$/g,function(){return C.cur;});});try{var live=window.BB_SHIP_RATES,lz=window.BB_ZONES;if(live&&lz)for(var st in C.zoneOf){var lad=live[lz[st]];if(lad)for(var mine=C.zones[C.zoneOf[st]].loose,i=0;i<mine.length;i++)lad[i]&&Math.round(lad[i].rate/100)!==mine[i]&&console.warn("[bb-freight-finder] ladder drift vs estimator at "+st+" band "+i+": finder $"+mine[i]+" vs estimator $"+Math.round(lad[i].rate/100))}}catch(e){}var CSS="#bb-ff{border:0;border-radius:0;background:transparent;box-shadow:none;padding:0;margin:0 0 8px}#bb-ff .bb-ff-top{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:12px 16px;margin-bottom:16px}#bb-ff h3{margin:0;font-size:19px;font-weight:700;color:#111827;letter-spacing:-.015em;text-align:center}#bb-ff select{font:inherit;font-size:15px;padding:10px 13px;border:1px solid #D1D5DB;border-radius:6px;background:#fff;max-width:100%;cursor:pointer;color:#111827}#bb-ff .bb-ff-auto{font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#6B7280;background:transparent;border:0;border-radius:0;padding:0;white-space:nowrap}#bb-ff .bb-ff-zone{margin:18px 0 2px;font-size:16px;font-weight:700;color:#111827;text-align:center}#bb-ff table{width:100%;border-collapse:separate;border-spacing:0;text-align:left;font-size:15px;table-layout:fixed;background:#fff;border:1px solid #C9C9C9;border-radius:9px;overflow:hidden}#bb-ff table th{border:0;padding:14px;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#5F5F5F;background:#fff;border-bottom:2px solid #EB673C;text-align:right;vertical-align:top}#bb-ff table th:first-child{text-align:left}#bb-ff table td{border:0;padding:14px;border-bottom:1px solid #EFEFEF;color:#1A1A1A;font-size:14px}#bb-ff table tbody tr:last-child td{border-bottom:0}#bb-ff table td.n{text-align:right;font-weight:600;font-size:15px}#bb-ff .q,#bb-ff .c{color:#111827}#bb-ff .bb-ff-note{font-size:13px;color:#6B7280;margin:14px 0 0;line-height:1.7}#bb-ff .bb-ff-warn{padding:16px 0;border-radius:0;line-height:1.7;font-size:14.5px;color:#111827}#bb-ff .bb-ff-warn.p,#bb-ff .bb-ff-warn.x{background:transparent;border:0;border-top:1px solid #E5E7EB;border-bottom:1px solid #E5E7EB}@media(max-width:520px){#bb-ff .bb-ff-top{flex-direction:column}#bb-ff table td{padding:11px 10px;font-size:13px}#bb-ff table th{padding:11px 10px;font-size:10px;letter-spacing:.04em}}#bb-ff table th.lane{text-align:right;vertical-align:top}#bb-ff table th:first-child{width:30%}#bb-ff table th .bb-ff-lane{display:block}#bb-ff table th .bb-ff-when{display:block;margin-top:5px;font-size:13px;font-weight:600;letter-spacing:0;text-transform:none;color:#1b7d2e;white-space:nowrap}#bb-ff table th .bb-ff-when.x{color:#6B7280}#bb-ff .bb-ff-lanes{display:flex;flex-wrap:wrap;justify-content:center;gap:10px 28px;margin:16px 0 0;font-size:13px;color:#6B7280;line-height:1.6;text-align:center}#bb-ff .bb-ff-lanes>div{flex:1 1 240px;min-width:0}#bb-ff .bb-ff-lanes strong{display:block;font-weight:700;color:#111827;margin-bottom:3px}@media(max-width:520px){#bb-ff table th .bb-ff-when{font-size:12px}}#bb-ff #bb-ff-lane .t{display:block;text-transform:uppercase;letter-spacing:.08em;font-weight:700;font-size:11px;color:#EB673C}#bb-ff #bb-ff-lane .p{display:block;font-size:13px;color:#5F5F5F;line-height:1.6;margin-top:4px;max-width:640px;margin-left:auto;margin-right:auto}@media(max-width:520px){#bb-ff #bb-ff-lane .p{font-size:12.5px}}#bb-ff table td.m{text-align:right;font-weight:600;font-size:15px}#bb-ff .bb-ff-lanes .w{display:block;font-size:13px;font-weight:600;color:#1b7d2e;margin-bottom:3px}#bb-ff table tr.bb-ff-hit td{background:#FDF1EC;font-weight:700;color:#1A1A1A}#bb-ff table tr.bb-ff-hit td:first-child{box-shadow:inset 3px 0 0 #EB673C}#bb-ff .bb-ff-you{display:inline-block;margin-left:8px;font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#fff;background:#EB673C;border-radius:99px;padding:2px 8px;vertical-align:middle}#bb-ff .bb-ff-min{margin:0 0 10px;font-size:13.5px;line-height:1.6;color:#8A3E14;background:#F9EFE7;padding:10px 12px;border-radius:8px}#bb-ff table td .bb-ff-sub{display:block;margin-top:3px;font-size:12.5px;font-weight:400;color:#6B7280;line-height:1.45}#bb-ff .bb-ff-lead{margin:0 0 10px;font-size:14.5px;line-height:1.6;color:#3A3A3A;text-align:center}#bb-ff table th .bb-ff-sub{display:block;margin-top:3px;font-size:9.5px;font-weight:600;color:#9A9A9A;text-transform:none;letter-spacing:0}#bb-ff table th.lane:not(:last-child),#bb-ff table td.n.q{text-align:center}#bb-ff table th.lane{white-space:nowrap}#bb-ff table td:first-child{white-space:nowrap}#bb-ff table th:first-child,#bb-ff table td:first-child{width:22%}#bb-ff table th:last-child,#bb-ff table td:last-child{width:22%}@media(max-width:560px){#bb-ff table{font-size:13px}#bb-ff table th,#bb-ff table td{padding:9px 6px}#bb-ff table th{font-size:9.5px;letter-spacing:.04em}}#bb-ff .bb-ff-tabs{display:none}#bb-ff .bb-ff-tab{flex:1 1 0;min-width:92px;-webkit-appearance:none;appearance:none;cursor:pointer;font-family:inherit;font-size:13px;font-weight:700;color:#5F5F5F;background:#fff;border:1px solid #C9C9C9;border-radius:9px;padding:9px 8px;text-align:center;line-height:1.3}#bb-ff .bb-ff-tab:hover{border-color:#EB673C;color:#1A1A1A}#bb-ff .bb-ff-tab.is-on{background:#EB673C;border-color:#EB673C;color:#fff}",st=document.createElement("style");st.textContent=CSS,document.head.appendChild(st);function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}var MON=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function md(d){return MON[d.getMonth()]+" "+d.getDate()}function dr(lo,hi){var n=new Date;return md(new Date(n.getTime()+lo*864e5))+" \u2013 "+md(new Date(n.getTime()+hi*864e5))}function optionList(sel){var served=[],paused=[],none=[];for(var k in C.names){var o='<option value="'+k+'"'+(k===sel?" selected":"")+">"+esc(C.names[k])+"</option>";C.zoneOf[k]?served.push(o):C.paused[k]?paused.push(o):none.push(o)}return'<option value="">Choose your '+C.unit+'\u2026</option><optgroup label="We deliver here">'+served.join("")+"</optgroup>"+(paused.length?'<optgroup label="Paused \u2014 reserve a window">'+paused.join("")+"</optgroup>":"")+(none.length?'<optgroup label="No delivery available">'+none.join("")+"</optgroup>":"")}function placeLabel(code,nm){try{var g=window.BBGeo&&window.BBGeo.get();if(g&&g.city&&g.state===code)return esc(g.city)+", "+esc(code)}catch(e){}return nm}var CURW=(window.BB_FF_COUNTRY==="CA"?"C$":"$");var _mxZ=(function(){for(var k in C.zones){var z2=C.zones[k];if(!z2.noCrane&&z2.crane)return z2}return null})();var _mxTxt=_mxZ?(CURW+_mxZ.loose[0]+" + "+CURW+_mxZ.crane[0]+" = "+CURW+(_mxZ.loose[0]+_mxZ.crane[0])):"";function bS(b){return String(b).split(/[\u2013\u2014]/)[0].trim()}function bE(b){var p=String(b).split(/[\u2013\u2014]/);return (p.length>1?p[1]:p[0]).trim()}var BB_FLOORS=[500,2500,5000,5000,10000,15000,25000],BB_CART=null,SEL_BAND=null;function bbCartBand(){if(BB_CART===null)return -1;var d=BB_CART/100;if(d<BB_FLOORS[0])return -1;for(var i=BB_FLOORS.length-1;i>=0;i--)if(d>=BB_FLOORS[i])return i;return -1;}function bbMinNote(){/* $500 order minimum, live 2026-10-26. ALWAYS stated - the table only implies it. */if(BB_CART===null||BB_CART<=0)return"";var d=BB_CART/100;if(d>=BB_FLOORS[0])return"";var gap=Math.ceil(BB_FLOORS[0]-d);return'<p class="bb-ff-min">Your cart is '+C.cur+d.toFixed(2)+' \u2014 add <strong>'+C.cur+gap+'</strong> to reach the '+C.cur+BB_FLOORS[0]+' minimum.</p>';}function body(code,auto){if(!code)return'<p class="bb-ff-note" style="margin:0"></p>';var nm=esc(C.names[code]||code);if(C.none[code])return'<div class="bb-ff-warn x" style="margin-top:14px"><strong style="color:#cc0000">No delivery to '+nm+" at this time.</strong><br>We\u2019re sorry \u2014 we can\u2019t reach you on our own trucks yet, and we don\u2019t hand freight to LTL carriers.</div>";if(C.paused[code]){var p=C.paused[code];return'<div class="bb-ff-warn p" style="margin-top:14px"><strong style="color:#bf360c">New orders to '+nm+" are paused.</strong> We can\u2019t keep up with demand, so we\u2019ve paused new orders here while we catch up. Existing orders are unaffected and ship as scheduled.<br>Service resumes <strong>"+esc(p[0])+"</strong> when our "+esc(p[1])+' hub opens \u2014 <a href="/pages/new-facilities#reserve">reserve a delivery window \u2192</a></div>'}for(var z=C.zones[C.zoneOf[code]],lt=C.lt[code],rows="",freeAt=-1,i2=0;i2<BANDS.length;i2++)if(z.loose[i2]===0&&z.crane&&z.crane[i2]===0){freeAt=i2;break}var NA='<span style="color:#888">Not available</span>';var mixOK=false;/* one profile: a cart is billed once, so there is no mixed total */function mcell(i){if(!mixOK)return"";var m=z.loose[i]+z.crane[i];return'<td class="n m">'+(m===0?"<strong>FREE</strong>":C.cur+m)+'</td>'}var _bandHdr='<th class="lane"><span class="bb-ff-lane">Delivery</span></th>',_tabs='';var _flat=1;for(var i3=1;i3<BANDS.length;i3++){if(z.loose[i3]!==z.loose[0]||(z.crane&&z.crane[i3]!==z.crane[0])){_flat=0;break}}var _m=function(v){return v===0?'FREE':C.cur+v};var _si=(function(){var o=[],p=null,q=null;for(var i=0;i<BANDS.length;i++){var a=z.loose[i],b=z.crane?z.crane[i]:null;if(a!==p||b!==q){o.push(i);p=a;q=b;}}return o;})();var _bidx=_si[0];_tabs='';_bandHdr='';for(var _k=0;_k<_si.length;_k++)_bandHdr+='<th class="lane"><span class="bb-ff-lane">'+(_k===0?'Min ':'')+BANDSC[_si[_k]]+'</span></th>';var _cells=function(L){var h='';for(var i=0;i<_si.length;i++)h+='<td class="n q"><strong>'+_m(L[_si[i]])+'</strong></td>';return h;};var _lrow=function(t,L,a,b){return '<tr><td><strong>'+t+'</strong></td>'+_cells(L)+'<td class="n" style="color:#1b7d2e;font-weight:600">'+dr(a,b)+'</td>'+mcell(0)+'</tr>'};rows=_lrow('Delivered & Unloaded',z.loose,lt[0],lt[1]);/* ONE LANE 2026-11-01: was three rows — Light, Heavy, and a third that SUMMED both ladders and printed $198. Light and Heavy are one delivery profile at one $99 rate now, so a cart is billed once and arrives on one truck; the sum described a double-bill that cannot happen. */_flat=1;freeAt=-1;return'<div class="bb-ff-zone">'+placeLabel(code,nm)+""/* zone name withheld 2026-10-05 - the band label is what reveals the map */+(auto?' <span class="bb-ff-auto">auto-detected</span>':"")+'</div>'+'<p class="bb-ff-lead">Your delivery rate drops as your order grows. One price for your address \u2014 not by weight, not by distance, and no surcharges.</p>'+_tabs+'<table><thead><tr><th>'+(_flat&&freeAt<0?'Delivery type':'Your order total')+'</th>'+_bandHdr+'<th class="lane"><span class="bb-ff-lane">Delivery dates</span></th>'+(mixOK?'<th class="lane"><span class="bb-ff-lane">Mixed Cart</span></th>':'')+'</tr></thead><tbody>'+rows+'</tbody></table>'+bbMinNote()+((_flat&&freeAt<0&&z.crane)?'<p class="bb-ff-note">One flat delivery price on any order, any material, any size — and it all arrives together on our own truck. We hold a minimum so we can keep our lead times, service and quality where they are.</p>':'')/* date now lives in the table; the repeat block and its gap are gone */}function render(code,auto){root.innerHTML='<div id="bb-ff"><div class="bb-ff-top"><h3>See your delivery price and dates</h3><select id="bb-ff-sel" aria-label="Select your '+C.unit+'">'+optionList(code)+'</select></div><div id="bb-ff-body">'+body(code,auto)+"</div></div>";var all=document.getElementById("bb-freight-all");all&&code&&(all.open=!1);if(!root._bbTabs){root._bbTabs=1;root.addEventListener("click",function(e){var t=e.target&&e.target.closest?e.target.closest("[data-bb-band]"):null;if(!t)return;e.preventDefault();SEL_BAND=+t.getAttribute("data-bb-band");var s2=document.getElementById("bb-ff-sel"),b2=document.getElementById("bb-ff-body");if(b2)b2.innerHTML=body(s2?s2.value:"",!1);});}var sel=document.getElementById("bb-ff-sel");sel.addEventListener("change",function(){var v=sel.value;try{v&&(window.BBGeo?window.BBGeo.set({region:v,source:"user"}):sessionStorage.setItem("bb_geo_state",v))}catch(e){}document.getElementById("bb-ff-body").innerHTML=body(v,!1);var a=document.getElementById("bb-freight-all");a&&v&&(a.open=!1)})}try{window.BBGeo&&window.BBGeo.subscribe(function(g){var s=document.getElementById("bb-ff-sel"),b=document.getElementById("bb-ff-body");if(!s||!b||!g||!g.state||!C.names[g.state])return;s.value=g.state;b.innerHTML=body(g.state,g.source!=="user")})}catch(e){}function bbCartRefresh(){try{fetch("/cart.js",{credentials:"same-origin"}).then(function(r){return r.ok?r.json():null}).then(function(c){if(!c||typeof c.total_price!=="number")return;if(c.total_price===BB_CART)return;BB_CART=c.total_price;var s=document.getElementById("bb-ff-sel"),b=document.getElementById("bb-ff-body");if(s&&b)b.innerHTML=body(s.value,!1);}).catch(function(){});}catch(e){}}bbCartRefresh();/* ⛔ ONE READ AT STARTUP WAS NOT ENOUGH. The minimum line names a GAP, so a stale cart total   tells the shopper to add money they already added. No single cart event covers the theme,   the slide cart and the steppers, so: hook fetch on /cart/ mutations, plus the usual custom   events, plus tab focus. The hook reads the URL only - request and response are untouched. */try{if(!window.__bbFFCartHook){window.__bbFFCartHook=1;var _oF=window.fetch;if(typeof _oF==="function"){window.fetch=function(){var _a=arguments,_u="";try{_u=(typeof _a[0]==="string")?_a[0]:((_a[0]&&_a[0].url)||"");}catch(e){}var _p=_oF.apply(this,_a);try{if(/\/cart\/(add|change|update|clear)/i.test(_u))_p.then(function(){setTimeout(bbCartRefresh,150);},function(){});}catch(e){}return _p;};}}}catch(e){}try{var _evs=["bb:cart-updated","cart:updated","cart:refresh","cart:change","ajaxCart.afterCartLoad"];for(var _ei=0;_ei<_evs.length;_ei++)document.addEventListener(_evs[_ei],function(){setTimeout(bbCartRefresh,80);});window.addEventListener("focus",bbCartRefresh);window.addEventListener("pageshow",bbCartRefresh);}catch(e){}var cached=null;try{cached=sessionStorage.getItem("bb_geo_state")}catch(e){}if(cached&&C.names[cached])render(cached,!0);else{render("",!1);try{window.BBGeo&&window.BBGeo.resolveIP(function(ip){var code=ip&&ip.region;if(!code||!C.names[code])return;window.BBGeo.set({region:code,city:ip.city,source:"ip"},{silent:!0});var sel=document.getElementById("bb-ff-sel");sel&&!sel.value&&(sel.value=code,document.getElementById("bb-ff-body").innerHTML=body(code,!0))})}catch(e){}}})();
//# sourceMappingURL=/cdn/shop/t/11/assets/bb-freight-finder.js.map
/* ==== BB MODULES v2026-08-14 ==== */

/* ── BarrierBoss zone jump ─────────────────────────────────────────────────
   Owner 2026-08-14: "it should also have an enter zip code or something or
   state here and jump to the zone type".

   Picks a state → switches the Standard/Extended toggle to whichever pane holds
   that state, highlights its row, and scrolls it into view.

   The state→zone lookup is BUILT BY READING THE TABLE (data-bb-tab /
   data-bb-states on each <tr>), so it can never drift from what is printed.
   Also fixes: the header ZIP change did not refresh anything — this listens for
   bb_geo_state updates via both the storage event and a custom event, so
   changing location elsewhere on the page moves the tables too.
   ⛔ Everything is guarded: if the markup is absent this exits silently.       */
(function () {
  'use strict';
  var NAMES = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'Washington DC',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};

  function init() {
    /* ⛔ ONE state control on the page, not two. The finder already asks "what
       does it cost, and how long does it take?" with its own <select>; adding a
       second "Where are you?" dropdown for the tables asked the same question
       twice. So the finder's select is the single input and it ALSO drives the
       tables. The .bb-zone-jump markup is gone; this stays tolerant of both. */
    var wrap = document.querySelector('.bb-zone-jump');
    var sel = document.getElementById('bb-zone-jump-sel');
    var rows = document.querySelectorAll('tr[data-bb-states]');
    if (!rows.length) return;                            // no tables → nothing to drive

    // build the lookup FROM THE TABLE
    var map = {};
    Array.prototype.forEach.call(rows, function (tr) {
      var tab = tr.getAttribute('data-bb-tab');
      tr.getAttribute('data-bb-states').split(',').forEach(function (raw) {
        var code = raw.trim().toUpperCase();
        if (code) map[code] = { tab: tab, row: tr };
      });
    });

    var codes = Object.keys(map).filter(function (c) { return NAMES[c]; })
      .sort(function (a, b) { return NAMES[a].localeCompare(NAMES[b]); });
    if (!codes.length) return;

    if (sel) codes.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c; o.textContent = NAMES[c];
      sel.appendChild(o);
    });
    if (wrap) wrap.hidden = false;

    function jump(code, scroll) {
      var hit = map[String(code || '').trim().toUpperCase()];
      Array.prototype.forEach.call(rows, function (tr) { tr.classList.remove('bb-zone-hit'); });
      if (!hit) return;
      var radio = document.getElementById(hit.tab === 'ext' ? 'bb-z-ext' : 'bb-z-std');
      if (radio) radio.checked = true;
      hit.row.classList.add('bb-zone-hit');
      if (sel && sel.value === '') sel.value = String(code).toUpperCase();
      if (scroll && hit.row.scrollIntoView) {
        hit.row.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    if (sel) sel.addEventListener('change', function () { jump(sel.value, true); });

    /* ── follow the site's geo, so a header ZIP change moves the tables ──────
       This used to poll sessionStorage every 700ms, because the `storage` event
       fires only in OTHER tabs — never in the tab that wrote the value — and a
       header ZIP entry is a same-tab write. BBGeo.subscribe() now emits on
       every write from every surface, so the poller is gone. The poller is kept
       ONLY as the fallback for a page where BBGeo failed to load, so behaviour
       degrades to exactly what it was rather than to nothing. */
    var GEO_KEYS = ['bb_geo_state', 'bb_geo_province', 'bb_geo_region', 'bb_geo_code'];
    function readGeo() {
      if (window.BBGeo) {
        var g = window.BBGeo.get();
        if (g && g.state && map[String(g.state).trim().toUpperCase()]) {
          return String(g.state).trim().toUpperCase();
        }
      }
      for (var i = 0; i < GEO_KEYS.length; i++) {
        try {
          var v = sessionStorage.getItem(GEO_KEYS[i]) || localStorage.getItem(GEO_KEYS[i]);
          if (v && map[String(v).trim().toUpperCase()]) return String(v).trim().toUpperCase();
        } catch (e) { /* private mode / blocked storage */ }
      }
      /* Fall back to whatever the finder resolved. It auto-detects and SETS its
         own select programmatically — and a programmatic assignment fires no
         'change' event, so polling its value is the only way to see it. This is
         what makes the table pre-select and pre-highlight on load. */
      var ff = document.getElementById('bb-ff-sel');
      if (ff && ff.value && map[String(ff.value).trim().toUpperCase()]) {
        return String(ff.value).trim().toUpperCase();
      }
      return null;
    }
    var lastGeo = null, userPicked = false;
    if (sel) sel.addEventListener('change', function () { userPicked = true; });
    function syncGeo(scroll) {
      var g = readGeo();
      if (!g || g === lastGeo) return;
      lastGeo = g;
      if (userPicked) return;   // never yank the table out from under a manual choice
      if (sel) sel.value = g;
      jump(g, scroll);
    }
    syncGeo(false);
    if (window.BBGeo && typeof window.BBGeo.subscribe === 'function') {
      window.BBGeo.subscribe(function () { syncGeo(false); });
    } else {
      setInterval(function () { syncGeo(false); }, 700);   /* fallback only */
    }
    // the finder re-renders on geo change; mirror its select when it does
    var ffSel = document.getElementById('bb-ff-sel');
    if (ffSel) ffSel.addEventListener('change', function () {
      if (!userPicked && map[String(ffSel.value).toUpperCase()]) {
        if (sel) sel.value = String(ffSel.value).toUpperCase();
        jump(ffSel.value, false);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ── ZIP entry inside the finder ───────────────────────────────────────────
   Owner: "And I need a zip code entry here" — in the finder's own control row,
   next to the state selector, not only in the gate above.

   Resolution now goes through window.BBGeo, the single shared geo layer. This
   module used to carry its OWN Canadian postal map and read a global bridge to
   a duplicate of the estimator's 904-prefix ZIP table appended alongside it;
   both are gone. BBGeo carries the estimator's table verbatim — the table that
   quotes the rate — so the finder can no longer name a different state than the
   estimator for the same code. Format decides the lookup, not the store.

   ⛔ A (Newfoundland & Labrador), X (NWT/Nunavut) and Y (Yukon) resolve to null
   inside BBGeo, so they read as "check that code" rather than quoting a rate we
   cannot honour.                                                              */
(function () {
  'use strict';
  var ID = 'bb-ff-zip';

  function resolve(raw) {
    if (!window.BBGeo) return null;   /* no guessing without the shared table */
    var r = window.BBGeo.resolveCode(raw);
    return r ? r.region : null;
  }

  /* ── acknowledgement ──────────────────────────────────────────────────────
     ⛔ THE BUG THIS FIXES: go() only did anything when the resolved region
     DIFFERED from the select's current value. Someone in Washington typing a
     Washington ZIP — the overwhelmingly common case, because the finder has
     already auto-detected them — pressed Check and got nothing at all. Not a
     wrong answer: NO answer. The button read as broken.
     Every press now acknowledges, whether or not the region moved, and the
     answer itself pulses so the eye is taken to the number rather than left on
     the button. */
  var CSS_ID = 'bb-ff-ack-css';
  function ensureCSS() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    /* The pulse is a background wash + a soft ring, never a layout change —
       nothing moves, so it cannot shift what someone is reading.
       prefers-reduced-motion gets NO animation at all; the button's text
       confirmation still lands, so the acknowledgement survives without it. */
    s.textContent =
      '@keyframes bb-ff-pulse{0%{background-color:rgba(235,103,60,.20)}100%{background-color:transparent}}'
      + '.bb-ff-pulsed{animation:bb-ff-pulse 1100ms ease-out 1}'
      + '@media (prefers-reduced-motion:reduce){.bb-ff-pulsed{animation:none}}';
    document.head.appendChild(s);
  }

  function pulse() {
    ensureCSS();
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) {}
    /* Queried AFTER the change has been dispatched, because the finder rebuilds
       #bb-ff-body synchronously inside that handler — these are the new nodes.
       The zone-jump row lives in the page's own table and is not rebuilt. */
    var targets = [
      document.querySelector('#bb-ff .bb-ff-zone'),
      document.querySelector('#bb-ff table tbody'),
      document.querySelector('tr.bb-zone-hit')
    ];
    for (var i = 0; i < targets.length; i++) {
      (function (el) {
        if (!el) return;
        el.classList.remove('bb-ff-pulsed');
        void el.offsetWidth;               /* restart the animation on a repeat press */
        el.classList.add('bb-ff-pulsed');
        setTimeout(function () { el.classList.remove('bb-ff-pulsed'); }, 1300);
      })(targets[i]);
    }
  }

  function inject() {
    var top = document.querySelector('#bb-ff .bb-ff-top');
    if (!top || document.getElementById(ID)) return;
    var sel = document.getElementById('bb-ff-sel');
    if (!sel) return;

    var wrap = document.createElement('span');
    wrap.style.cssText = 'display:inline-flex;align-items:center;gap:6px;';

    var inp = document.createElement('input');
    inp.id = ID;
    inp.type = 'text';
    inp.inputMode = (location.hostname.indexOf('.ca') > -1) ? 'text' : 'numeric';
    inp.maxLength = 7;
    inp.autocomplete = 'postal-code';
    inp.placeholder = 'or ZIP';
    inp.setAttribute('aria-label', 'Enter your ZIP or postal code');
    inp.style.cssText = 'font:inherit;font-size:16px;padding:10px 12px;width:118px;text-align:center;' +
      'border:1px solid #C9C9C9;border-radius:6px;background:#fff;color:#1A1A1A;';

    var note = document.createElement('span');
    /* :empty hides it, so an empty note holds no flex gap open — see the
       BB EMPTY-STATE FIT module. */
    note.className = 'bb-ff-err';
    note.style.cssText = 'font-size:12px;color:#B3261E;';

    /* Announced to screen readers, which see neither the pulse nor the button's
       colour change. aria-live on its own node so it is not re-created. */
    var live = document.createElement('span');
    live.setAttribute('aria-live', 'polite');
    live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';

    var go_btn = document.createElement('button');
    go_btn.type = 'button';
    go_btn.textContent = 'Check';
    var BTN_BASE = 'font:inherit;font-size:15px;font-weight:600;padding:10px 18px;border-radius:6px;cursor:pointer;';
    var BTN_IDLE = BTN_BASE + 'border:1px solid #EB673C;background:#EB673C;color:#fff;';
    var BTN_DONE = BTN_BASE + 'border:1px solid #1B7F4C;background:#1B7F4C;color:#fff;';
    go_btn.style.cssText = BTN_IDLE;

    var restoreT = null;
    function ack(region) {
      var name = region;
      try {
        var opt = sel.querySelector('option[value="' + region + '"]');
        if (opt && opt.textContent) name = opt.textContent.trim();
      } catch (e) {}
      go_btn.textContent = 'Updated';
      go_btn.style.cssText = BTN_DONE;
      live.textContent = 'Showing delivery for ' + name + '.';
      clearTimeout(restoreT);
      restoreT = setTimeout(function () {
        go_btn.textContent = 'Check';
        go_btn.style.cssText = BTN_IDLE;
      }, 1600);
      pulse();
    }

    function go() {
      var st = resolve(inp.value);
      if (!st) {
        /* A code we cannot place is a FORMAT problem, never "we don't deliver
           there" — those two must never read the same. */
        note.textContent = inp.value ? 'Check that code' : '';
        live.textContent = inp.value ? 'That code was not recognised. Check it and try again.' : '';
        return;
      }
      note.textContent = '';
      if (sel.value !== st) {
        sel.value = st;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      /* Upgrade the region to a real city + coordinates from the lazy shard, so
         the resolved line reads "Beverly Hills, CA → California Standard" and the
         delivery-proof line can compute a distance. BBGeo emits on success, and
         the finder re-renders itself from that; on failure it is silent and the
         region-only line simply stays. */
      if (window.BBGeo) window.BBGeo.resolveCity(inp.value, st, function () {});
      /* ⛔ OUTSIDE the if. The unchanged case is precisely the one that looked
         dead, so it is the one that most needs an answer. */
      ack(st);
    }

    /* ⛔ DO NOT rewrite inp.value on every keystroke, and DO NOT auto-submit as
       soon as 5 digits land. Both break typing on a phone:
        · reassigning .value mid-composition fights the soft keyboard's
          autocorrect/predictive layer and drops characters;
        · submitting on the 5th digit fires a change, the finder re-renders the
          body, and the answer moves under the shopper mid-type.
       Submit only on an explicit Enter or press, and sanitise at submit time. */
    /* ⛔ NO blur handler. Pressing the button blurs the input first; blur ran
       go(), which fired a change before the click could land, so the press
       appeared to do nothing. The button submits on mousedown WITH
       preventDefault so focus never leaves the input in the first place; click
       stays bound because keyboard activation emits click only. */
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
    go_btn.addEventListener('mousedown', function (e) { e.preventDefault(); go(); });
    go_btn.addEventListener('click', function (e) { e.preventDefault(); go(); });

    wrap.appendChild(inp);
    wrap.appendChild(go_btn);
    wrap.appendChild(note);
    wrap.appendChild(live);
    top.appendChild(wrap);

    /* Owner: "I think it should just be one box?" — the state dropdown and the
       ZIP field asked the same question twice. ZIP is the one people actually
       know, so it becomes the only visible control.
       ⛔ The <select> is HIDDEN, never removed: it is the finder's own control
       and every downstream listener (the finder's render, the zone-jump row
       highlight) reads and fires from it. Removing it breaks all of them. */
    sel.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;' +
      'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    sel.setAttribute('aria-hidden', 'true');
    sel.tabIndex = -1;
    inp.placeholder = (location.hostname.indexOf('.ca') > -1) ? 'Your postal code' : 'Your ZIP code';
    inp.style.width = '150px';
  }

  function start() {
    ensureCSS();
    inject();
    var root = document.getElementById('bb-freight-finder');
    if (!root || !window.MutationObserver) return;
    /* The finder rebuilds #bb-ff-body on change and the whole widget on its
       async IP resolve; re-inject rather than binding once at load. */
    new MutationObserver(function () { inject(); })
      .observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ── Delivery proof on the shipping page ───────────────────────────────────
   Owner: bring the PDP's neighbour line across. The PDP renders

     🏠 We've Delivered to 70 Neighbors near you · Closest ~2 mi
     ETA to Beverly Hills, CA · Sep 25–Oct 9 · change

   and this renders the first half plus the place:

     We've Delivered to 70 Neighbors near you · Closest ~2 mi · Beverly Hills, CA

   ⛔ NOT A SECOND IMPLEMENTATION. The count and the distance come from
   bb-order-proof.js's own lineFor() — the same function, the same haversine,
   the same 50-mile radius as the PDP. This module only loads that asset,
   waits for it, and places the result. Nothing about the number is computed
   here, so the two surfaces cannot disagree.

   ⛔ LIVE SOURCE ONLY. bb-order-proof.js ships a baked snapshot for first
   paint whose coordinates are rounded to ONE decimal place — about ±3.4 mi,
   which cannot honestly support a "~2 mi" claim — and whose USA counts
   (1,762) overstate the live figure (1,324) by a third. We therefore wait for
   BBProof.live, which is set only once the cron-refreshed /delivery-coords
   response has replaced both arrays at 3-decimal precision. If that fetch
   fails we render NOTHING: no placeholder, no softened wording, no snapshot.

   ⛔ NO ETA CLAUSE. The PDP knows which product is being bought and so knows
   which lane applies; a shipping page does not, and the table directly below
   legitimately shows both windows. Printing one of them here would be picking
   arbitrarily and contradicting the table on the same screen.

   ⛔ NO "change" AFFORDANCE. The ZIP field in .bb-ff-top already does that.

   Emoji stripped to match the page, which is emoji-free on both stores.       */
(function () {
  'use strict';
  var ID = 'bb-ff-proof';

  /* The two stores expose DIFFERENT globals — window.BBProof on USA,
     window.BBProofCA on Canada — and Canada's counts live in PROVCOUNTS
     rather than COUNTS. Both now carry the same proofLine() wrapper, so this
     is the only place the difference has to be known. */
  function proof() { return window.BBProof || window.BBProofCA || null; }

  function assetUrl(name) {
    var s = document.querySelector('script[src*="bb-freight-finder"]')
         || document.querySelector('script[src*="bb-geo"]');
    var src = s && s.src ? s.src : '';
    if (!src) return null;
    return src.replace(/[^\/]*$/, name);
  }

  /* bb-order-proof.js is 23-34KB and is PDP/cart-only today, so it is fetched
     lazily and only once we actually have a region to ask about. */
  var loading = false;
  function loadProof(cb) {
    if (proof()) { cb(); return; }
    if (loading) { document.addEventListener('bb:proof-live', function () { cb(); }); return; }
    loading = true;
    var store = (window.BB_FF_COUNTRY === 'CA') ? 'bb-order-proof-ca.js' : 'bb-order-proof.js';
    var url = assetUrl(store);
    if (!url) return;
    var sc = document.createElement('script');
    sc.src = url; sc.async = true;
    sc.onload = function () { cb(); };
    sc.onerror = function () { /* silent: no proof line, no message */ };
    document.head.appendChild(sc);
  }

  /* ⛔ Canada's live /delivery-coords feed returns 56 region keys for a
     13-province country and includes US states — "UT":11 among them. Rendering
     a region label straight from that aggregate could tell a Canadian visitor
     "11 Neighbours in UT chose BarrierBoss". The label is therefore gated
     against the real region set for the store and anything outside it renders
     NOTHING. (The aggregate itself needs fixing at source — out of scope.) */
  var CA_REGIONS = { BC:1, AB:1, SK:1, MB:1, ON:1, QC:1, NB:1, NS:1, PE:1, NL:1, YT:1, NT:1, NU:1 };
  var US_REGIONS = { AL:1,AK:1,AZ:1,AR:1,CA:1,CO:1,CT:1,DE:1,DC:1,FL:1,GA:1,HI:1,ID:1,IL:1,IN:1,IA:1,
    KS:1,KY:1,LA:1,ME:1,MD:1,MA:1,MI:1,MN:1,MS:1,MO:1,MT:1,NE:1,NV:1,NH:1,NJ:1,NM:1,NY:1,NC:1,ND:1,
    OH:1,OK:1,OR:1,PA:1,RI:1,SC:1,SD:1,TN:1,TX:1,UT:1,VT:1,VA:1,WA:1,WV:1,WI:1,WY:1 };
  function regionAllowed(code) {
    var set = (window.BB_FF_COUNTRY === 'CA') ? CA_REGIONS : US_REGIONS;
    return !!(code && set[String(code).toUpperCase()]);
  }

  /* Sits directly under the control row: heading + ZIP field, then the proof,
     then the resolved zone line and the table.
     #bb-ff-body is rebuilt wholesale on every render, so the previous copy is
     already gone by the time this runs — re-inserting as its first child is
     therefore self-cleaning and needs no dedupe. (It DID need one while this
     lived above .bb-ff-top, which survives renders; that workaround is removed
     rather than left alongside a mechanism that no longer needs it.) */
  function place(html) {
    var body = document.getElementById('bb-ff-body');
    if (!body) return;
    var el = document.getElementById(ID);
    if (!el) {
      el = document.createElement('p');
      el.id = ID;
      el.style.cssText = 'font-size:13px;font-weight:600;color:#111827;margin:0 0 6px;line-height:1.6;text-align:center';
    }
    /* idempotent: writing nothing when it is already right is what keeps the mount observer
       below from re-entering on its own mutation */
    if (el.innerHTML !== html) el.innerHTML = html;
    if (el.parentNode !== body || body.firstChild !== el) body.insertBefore(el, body.firstChild);
  }

  /* The region the FINDER has resolved — read straight off its own select, which is what the
     page is actually showing. Falls back to nothing rather than guessing. */
  function selectedRegion() {
    var sel = document.getElementById('bb-ff-sel');
    var v = sel && sel.value ? String(sel.value).toUpperCase() : '';
    return regionAllowed(v) ? v : '';
  }

  function render() {
    var P = proof();
    /* ⛔ P.live is the LIVE-SOURCE gate. Without it we would be rendering the
       baked snapshot, whose 1-decimal coordinates cannot support a distance
       claim and whose USA counts overstate the live figure by about a third. */
    if (!P || !P.live) return;

    var g = (window.BBGeo && window.BBGeo.get()) || null;
    var geoRegion = (g && g.state && regionAllowed(g.state)) ? String(g.state).toUpperCase() : '';
    var typed = selectedRegion();
    var region = typed || geoRegion;
    if (!region) return;                     /* nothing resolved yet -> nothing claimed */

    /* ⛔ THE DISTANCE CLAIM NEEDS REAL COORDINATES FOR THE PLACE BEING SHOWN.
       Coordinates come from IP geo, so they only describe the visitor. The moment the customer
       types a code for somewhere else, "Closest ~1 mi" would be a statement about the wrong
       place. So coords are used ONLY when the typed region and the geo region are the same;
       otherwise we fall back to the region-level count, which is true either way. */
    var useCoords = geoRegion && region === geoRegion && g && g.lat != null && g.lng != null;
    var arg = useCoords ? { region: region, lat: g.lat, lng: g.lng } : { region: region };

    var line = null;
    try { line = P.proofLine ? P.proofLine(arg) : null; } catch (e) { return; }
    if (!line) return;                       /* unserved / no data -> nothing */
    line = line.replace(/^\s*🏠\s*/, '');   /* drop the house emoji */
    /* ⛔ NO CITY CLAUSE. Appending "City, Region" here put the same place on
       screen twice, four lines apart — once ending this line and once opening
       the zone line immediately below. The zone line already carries it, paired
       with the zone name where it belongs. This line ends at the distance. */
    place(line);
  }

  function start() {
    if (!document.getElementById('bb-freight-finder')) return;
    /* ⛔ DO NOT GATE THE LOAD ON IP GEO. It used to return unless BBGeo had already resolved,
       so a visitor whose geo never resolves — or who sits outside the store's country, which
       regionAllowed correctly refuses — never even fetched the proof data, and no amount of
       typing a code could bring the line back. The finder's own selection is enough. */
    loadProof(function () { render(); });
  }

  if (window.BBGeo && typeof window.BBGeo.subscribe === 'function') {
    window.BBGeo.subscribe(function () { start(); render(); });
  }
  document.addEventListener('bb:proof-live', render);

  /* ⛔ #bb-ff-body IS REBUILT WHOLESALE ON EVERY CHECK, which destroys the proof node. Nothing
     re-inserted it, so the line vanished the moment a customer looked up a code — the one action
     that proves they are interested. This re-places it after each rebuild.
     The re-entrancy guard matters: place() mutates the same body, so an unguarded observer would
     re-enter on its own write. */
  /* ⛔ #bb-ff-body IS REPLACED WHOLESALE on every check, so an observer bound to it dies with
     it — that is why the line vanished the moment a customer looked up a code, the one action
     that proves they are interested. The MOUNT comes from the page template and survives, so the
     observer binds there instead and catches every rebuild.
     place() is idempotent, so our own insert emits no mutation and this cannot loop. */
  function watchRoot() {
    var root = document.getElementById('bb-freight-finder');
    if (!root || root.__bbProofWatched) return;
    root.__bbProofWatched = true;
    new MutationObserver(function () { render(); }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); watchRoot(); });
  else { start(); watchRoot(); }
})();

/* ── Next step, at the end of the rates section ────────────────────────────
   Someone who has just seen "$49, arrives Aug 28 – Sep 11 to Beverly Hills"
   has had their objection answered and nowhere to go. This is the onward step.

   Injected from the finder rather than added to the page template, so the
   shipping page's own content stays untouched.

   ⛔ LINK, never embed, for the calculator: sections/fence-configurator.liquid
   is ~380KB with a Google Maps dependency and its own Google-Places geo
   resolver. Putting that on this page would undo the single-source geo work
   and the page-weight discipline in one move.

   Copy is deliberately bare. "Fence Calculator" is the store's OWN label for
   it in the header on both stores; no descriptive claim is made about what the
   tool does, because none could be verified from the store's own copy.        */
(function () {
  'use strict';
  var ID = 'bb-ff-cta';

  /* Verified 200 + published via the Admin API on BOTH stores. The page TITLE
     differs per store ("Fence Configurator" / "Design Your Fence") but the
     handle is the same, so one URL is correct for both. */
  var CALC_URL = '/pages/fence-configurator';

  /* ⛔ Placement: BELOW the rates tables, not inside the finder.
     Injecting into #bb-freight-finder put this directly under the finder's own
     result and ABOVE the tables — a "what next" step offered before the thing
     it comes after. It now mounts immediately AFTER the Fence Finder quiz
     section, which already sits after all the rates content, so the two tools
     read as one adjacent block: tables -> lanes -> footnotes -> quiz +
     calculator — the onward step comes last, after both tools.
     ⛔ The quiz is the ANCHOR, not a requirement. If that section is absent or
     renamed the card falls back to the end of the rates section (its previous
     home) and then to the finder itself. It must never vanish. */
  function anchor() {
    var quiz = document.querySelector('[id$="__bb_fence_finder_quiz"]')
            || document.getElementById('shopify-section-bb_fence_finder_quiz');
    if (quiz && quiz.parentNode) return { parent: quiz.parentNode, before: quiz.nextSibling };
    var ff = document.getElementById('bb-freight-finder');
    var sec = ff && ff.closest ? ff.closest('[id*="shopify-section"], [id*="__"]') : null;
    if (sec && sec.parentNode) return { parent: sec.parentNode, before: sec.nextSibling };
    return ff ? { parent: ff.parentNode, before: ff.nextSibling } : null;
  }

  function build() {
    if (document.getElementById(ID)) return;
    var at = anchor();
    if (!at) return;

    var wrap = document.createElement('div');
    wrap.id = ID;
    /* Generous top separation so it reads as a distinct next step rather than
       another footnote, matching the section spacing used elsewhere here. */
    wrap.style.cssText = 'margin:56px 0 8px;display:flex;flex-wrap:wrap;justify-content:center;gap:12px;';

    /* Page's own system: #E3E3E3 hairline, 6px radius (the finder's select and
       ZIP field already use both), #1A1A1A text, #EB673C only as the accent.
       No new colour, no new radius, no emoji. */
    var a = document.createElement('a');
    a.href = CALC_URL;
    a.id = 'bb-ff-cta-calc';
    a.style.cssText = 'display:inline-flex;align-items:center;gap:8px;padding:14px 24px;'
      + 'border:1px solid #E3E3E3;border-radius:6px;background:#fff;color:#1A1A1A;'
      + 'font:inherit;font-size:15px;font-weight:700;text-decoration:none;line-height:1.2;';
    a.innerHTML = 'Fence Calculator<span aria-hidden="true" style="color:#EB673C">→</span>';
    wrap.appendChild(a);

    /* ══════════════════════════════════════════════════════════════════════
       INSERTION POINT — zone-aware shop CTA.

       Held out deliberately. The target collection exists on BOTH stores with
       exactly 9 sellable products (handle: quick-ship-unframed) but is NOT yet
       published to the Online Store channel, so both URLs return 404. Shipping
       a CTA to a 404 is worse than shipping none, and /collections/hog-fencing
       is NOT a stand-in: it lacks the deck railing and cattle panels this copy
       would promise.

       Once the owner publishes both collections, this becomes ONE small change
       — append a second <a> here pointing at
         '/collections/quick-ship-unframed'
       labelled with the resolved region from window.BBGeo.get().state, e.g.
       "Shop what ships to British Columbia". Verify 200 per store first.
       ══════════════════════════════════════════════════════════════════════ */

    at.parent.insertBefore(wrap, at.before);
  }

  function start() {
    build();
    var root = document.getElementById('bb-freight-finder');
    if (!root || !window.MutationObserver) return;
    /* the finder rebuilds its innards on every region change; this block now
       lives outside it, but re-check rather than assume */
    new MutationObserver(function () { build(); }).observe(root, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ==== BB FINDER-RATES LINK 2026-08-15 ==== */
(function () {
  'use strict';
  var BLANK = 'bb-ff-blank', RESOLVED = 'bb-rates-resolved', GENERIC = null;

  function ensureCSS() {
    if (document.getElementById('bb-ff-link-css')) return;
    var s = document.createElement('style');
    s.id = 'bb-ff-link-css';
    /* the blank-state rule targets the NEXT SIBLING of the finder's wrapper.
       That used to be a divider <div>; the divider is gone now and a <section>
       follows, so the selector must not name a tag. */
    s.textContent = '#bb-ff .bb-ff-err:empty{display:none}' +
      '.bb-ff-blank #bb-ff-cta{margin-top:24px!important}' +
      '.bb-ff-blank + *{margin-top:24px!important}' +
      '.bb-rates-resolved .bb-zone-tabs{display:none}';
    document.head.appendChild(s);
  }

  /* Read the place out of the finder's own output rather than re-deriving it.
     No .bb-ff-zone means nothing resolved — empty state, an unrecognised code,
     or an area we do not serve (.bb-ff-warn) — and the heading stays generic. */
  function placeOf() {
    var z = document.querySelector('#bb-ff-body .bb-ff-zone');
    if (!z || !z.firstChild || z.firstChild.nodeType !== 3) return '';
    return z.firstChild.textContent.replace(/\u2192\s*$/, '').trim();
  }

  /* the empty state is EXACTLY one <p class="bb-ff-note"> and nothing else.
     The resolved body no longer ends with a note — the owner dropped that
     reassurance line on 2026-08-15 — so it now has three children (zone,
     table, lanes). Still never one, so this test is unaffected. */
  function isBlank(b) {
    return !!b && b.children.length === 1 &&
      b.firstElementChild.tagName === 'P' &&
      b.firstElementChild.classList.contains('bb-ff-note');
  }

  /* Which pane holds this region? Read STRAIGHT OFF THE TABLE (data-bb-tab on
     the row carrying the region), so it can never drift from what is printed. */
  function paneFor(code) {
    if (!code) return '';
    var rows = document.querySelectorAll('tr[data-bb-states]');
    for (var i = 0; i < rows.length; i++) {
      var list = (rows[i].getAttribute('data-bb-states') || '').split(',');
      for (var j = 0; j < list.length; j++)
        if (list[j].trim().toUpperCase() === code) return rows[i].getAttribute('data-bb-tab') || '';
    }
    return '';
  }

  function sync() {
    var root = document.getElementById('bb-freight-finder');
    if (!root || !root.parentNode || root.parentNode.nodeType !== 1) return;
    ensureCSS();
    root.parentNode.classList.toggle(BLANK, isBlank(document.getElementById('bb-ff-body')));

    var place = placeOf();
    var h = document.querySelector('[data-bb-rates-heading]');
    if (h) {
      if (GENERIC === null) GENERIC = h.textContent;
      var want = place ? 'Rates to ' + place : GENERIC;
      if (h.textContent !== want) h.textContent = want;
    }

    /* ⛔ The toggle may only be hidden once the visitor has ACTUALLY been put in
       the right pane — hiding it while the wrong pane showed would strand them
       on rates that do not apply, with no way back. So this module selects the
       pane itself rather than trusting another module to have done it, and
       hides the toggle only when that succeeded. */
    var sel = document.getElementById('bb-ff-sel');
    var code = sel && sel.value ? String(sel.value).trim().toUpperCase() : '';
    var pane = place ? paneFor(code) : '';
    if (pane) {
      var radio = document.getElementById(pane === 'ext' ? 'bb-z-ext' : 'bb-z-std');
      if (radio && !radio.checked) radio.checked = true;
    }
    var body = document.querySelector('.bb-rates-body');
    if (body) body.classList.toggle(RESOLVED, !!pane);
  }

  function boot() {
    sync();
    var root = document.getElementById('bb-freight-finder');
    /* #bb-ff-body is replaced wholesale on every render path (initial, select
       change, BBGeo subscribe), so observe the root instead of patching three
       call sites. */
    if (root && window.MutationObserver) new MutationObserver(sync).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* ============================================================================
   COVERAGE MAP — sits under the rate table on the shipping page. 2026-10-22.
   Owner: "can you put a map of our current coverage areas and paused zones".

   ⛔ THE LATTICE IS A SCHEMATIC, NOT A PROJECTION. Each cell is a postal code on a coarse
      geographic grid. No boundary or coordinate data is invented, and every cell is asserted
      against the finder's own names map at build time by _add_coverage_map.mjs.
   ⛔ NO ZONE NAMES. The zones set the route, not the price; naming one reveals the map.
   ⛔ A region in NO map falls through to "no date yet". It must never default to served.
   ⛔ The text list under the grid is the accessible and crawlable half — it NAMES THE STATES,
      which is also the only honest way to state coverage now that reach words are banned.
   ⭐ Inserted as a SIBLING after the table's note: render() replaces root.innerHTML on every
      path, so anything placed inside the root would be wiped on the next select change.
   ============================================================================ */
(function(){
  var US_GRID=[["","","","","","","","","","","","","ME"],["","WA","ID","MT","ND","MN","","WI","MI","","NY","VT","NH"],["","OR","NV","WY","SD","IA","IL","IN","OH","PA","NJ","CT","MA"],["","CA","UT","CO","NE","MO","KY","WV","MD","DE","DC","RI",""],["","","AZ","NM","KS","AR","TN","VA","NC","SC","","",""],["","","","","OK","LA","MS","AL","GA","","","",""],["AK","","","TX","","","","","FL","","","",""],["HI","","","","","","","","","","","",""]];
  var CA_GRID=[["","YT","NT","NU","","","","","NL"],["","BC","AB","SK","MB","ON","QC","","PE"],["","","","","","","NB","NS",""]];
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}

  var CSS='#bb-coverage{max-width:760px;margin:6px auto 34px;padding:0 24px;font-family:inherit;color:#1A1A1A}'
   +'#bb-coverage .bb-cv-h{font-size:17px;font-weight:800;margin:0 0 2px;text-align:center}'
   +'#bb-coverage .bb-cv-sub{font-size:13.5px;color:#6b6b6b;margin:0 0 12px;text-align:center;line-height:1.5}'
   +'#bb-coverage .bb-cv-key{display:flex;flex-wrap:wrap;gap:6px 14px;justify-content:center;margin:0 0 12px;font-size:12.5px}'
   +'#bb-coverage .bb-cv-key span{display:inline-flex;align-items:center;gap:6px;white-space:nowrap}'
   +'#bb-coverage .bb-cv-sw{width:12px;height:12px;border-radius:3px;flex:0 0 auto}'
   +'#bb-coverage .bb-cv-grid{--cv:clamp(17px,6.2vw,30px);display:grid;gap:2px;justify-content:center;margin:0 auto 10px}'
   +'#bb-coverage .bb-cv-c,#bb-coverage .bb-cv-x{width:var(--cv);height:var(--cv);border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:clamp(8px,2.3vw,11.5px);font-weight:700;letter-spacing:-.2px}'
   +'#bb-coverage .bb-cv-x{background:transparent}'
   +'#bb-coverage .bb-cv-c{cursor:default}'
   +'#bb-coverage .bb-cv--served{background:#EB673C;color:#fff}'
   +'#bb-coverage .bb-cv--paused{background:#FDEBD9;color:#9a5a33;border:1px dashed #E0A478;box-sizing:border-box}'
   +'#bb-coverage .bb-cv--none{background:#F1F1F1;color:#666666}'
   +'#bb-coverage .bb-cv-map{display:block;width:100%;max-width:720px;height:auto;margin:0 auto 10px}'
   +'#bb-coverage .bb-cv-st{stroke:#fff;stroke-width:1;vector-effect:non-scaling-stroke;cursor:default;transition:opacity .12s ease}'
   +'#bb-coverage .bb-cv-st.bb-cv--served{fill:#EB673C;stroke:#fff;stroke-width:1.6;filter:url(#bbCvPop)}'
   +'#bb-coverage .bb-cv-st.bb-cv--paused{fill:#FBE4D2;stroke:#fff;stroke-width:.9}'
   +'#bb-coverage .bb-cv-st.bb-cv--none{fill:#EDEDED;stroke:#fff;stroke-width:.9}'
   +'#bb-coverage .bb-cv-labels{pointer-events:none}'
   +'#bb-coverage .bb-cv-lb{font-family:inherit;font-weight:800;font-size:15px;letter-spacing:.2px}'
   +'#bb-coverage .bb-cv-lb--served{fill:#fff}'
   +'#bb-coverage .bb-cv-lb--paused{fill:#A96A42}'
   +'#bb-coverage .bb-cv-lb--none{fill:#9A9A9A}'
   +'#bb-coverage .bb-cv-st:hover{opacity:.78}'
   +'#bb-coverage .bb-cv-read{min-height:1.4em;text-align:center;font-size:13px;font-weight:600;color:#9a5a33;margin:0 0 14px}'
   +'#bb-coverage .bb-cv-list{font-size:13.5px;line-height:1.6;margin:0}'
   +'#bb-coverage .bb-cv-list p{margin:0 0 8px}'
   +'#bb-coverage .bb-cv-list b{display:block;font-size:12.5px;text-transform:uppercase;letter-spacing:.4px;color:#1A1A1A}'
   +'#bb-coverage .bb-cv-list i{font-style:normal;color:#4a4a4a}'
   +'@media(max-width:480px){#bb-coverage{padding:0 16px}}';

  function statusOf(D,c){
    /* ⛔ paused and none are checked FIRST, and an unknown code falls through to 'none'.
       Never default to served — that is the claim we cannot take back. */
    if(D.paused&&D.paused[c])return 'paused';
    if(D.none&&D.none.indexOf(c)>-1)return 'none';
    if(D.served&&D.served.indexOf(c)>-1)return 'served';
    return 'none';
  }

  function build(D){
    var grid=D.country==='CA'?CA_GRID:US_GRID, unit=D.country==='CA'?'province':'state';
    var n={served:0,paused:0,none:0},r,c,code,st;
    for(r=0;r<grid.length;r++)for(c=0;c<grid[r].length;c++){ if(grid[r][c]) n[statusOf(D,grid[r][c])]++; }

    /* ⭐ REAL MAP when the Census outlines are available (US only). Falls back to the lattice
       if the asset has not loaded, so coverage is never a blank box. */
    var mapSvg='';
    var MP = (D.country==='CA') ? window.BB_CA_MAP : window.BB_US_MAP;
    if(MP && MP.paths){
      var seg='', labs='';
      /* ⛔ area floor: DC is 7 and RI is 118 against Texas at 28,678. Below this a label is
         unreadable and overlaps its neighbours. Served regions bypass it — all are large. */
      var MIN_AREA = (D.country==='CA') ? 900 : 1200;  /* retained: served-only labelling makes it moot, kept for any future opt-in */
      for(var code in MP.paths){
        var mst=statusOf(D,code), mnm=D.names[code]||code, mlab;
        if(mst==='served')mlab=mnm+' \u2014 delivering now';
        else if(mst==='paused')mlab=mnm+' \u2014 delivery opens '+D.paused[code][0]+(D.paused[code][1]===mnm?' from our hub here':' from our '+D.paused[code][1]+' hub');
        else mlab=mnm+' \u2014 no date yet';
        seg+='<path d="'+MP.paths[code]+'" class="bb-cv-st bb-cv--'+mst+'" data-l="'+esc(mlab)+'"><title>'+esc(mlab)+'</title></path>';
        var an=(MP.labels||{})[code];
        /* ⭐ OWNER 2026-10-22: ONLY regions we service are labelled. The rest keep their shape and
             colour but carry no abbreviation, so the eye lands on coverage. This also retires the
             area floor problem entirely — every served region is large enough to hold text. */
          if(an && mst==='served'){
          labs+='<text class="bb-cv-lb bb-cv-lb--'+mst+'" x="'+an[0]+'" y="'+an[1]+'" text-anchor="middle" dominant-baseline="central">'+esc(code)+'</text>';
        }
      }
      mapSvg='<svg class="bb-cv-map" viewBox="'+MP.viewBox+'" role="img" aria-label="Delivery coverage map" preserveAspectRatio="xMidYMid meet">'
        +'<defs><filter id="bbCvPop" x="-20%" y="-20%" width="140%" height="140%">'
        +'<feDropShadow dx="0" dy="1.5" stdDeviation="2" flood-color="#8a3415" flood-opacity="0.35"/></filter></defs>'
        +'<g>'+seg+'</g><g class="bb-cv-labels">'+labs+'</g></svg>';
    }

    var cells='';
    for(r=0;r<grid.length;r++)for(c=0;c<grid[r].length;c++){
      code=grid[r][c];
      if(!code){cells+='<i class="bb-cv-x" aria-hidden="true"></i>';continue}
      st=statusOf(D,code);
      var nm=D.names[code]||code,lab;
      if(st==='served')lab=nm+' \u2014 delivering now';
      else if(st==='paused')lab=nm+' \u2014 delivery opens '+D.paused[code][0]+(D.paused[code][1]===nm?' from our hub here':' from our '+D.paused[code][1]+' hub');
      else lab=nm+' \u2014 no date yet';
      cells+='<span class="bb-cv-c bb-cv--'+st+'" data-l="'+esc(lab)+'" title="'+esc(lab)+'" role="img" aria-label="'+esc(lab)+'">'+esc(code)+'</span>';
    }

    /* the text half: names the regions, carries the dates, and is what a crawler reads */
    function nameList(codes){
      return codes.map(function(x){return D.names[x]||x}).sort().join(', ');
    }
    var servedNames=nameList(D.served);
    var groups={},k;
    for(k in (D.paused||{})){var g=D.paused[k][0]+'\u0001'+D.paused[k][1];(groups[g]=groups[g]||[]).push(k)}
    var gKeys=Object.keys(groups).sort();
    var list='<p><b>Delivering now</b><i>'+esc(servedNames)+'</i></p>';
    for(var i=0;i<gKeys.length;i++){
      var parts=gKeys[i].split('\u0001');
      list+='<p><b>Opens '+esc(parts[0])+', from our '+esc(parts[1])+' hub</b><i>'+esc(nameList(groups[gKeys[i]]))+'</i></p>';
    }
    if(D.none&&D.none.length)list+='<p><b>No date yet</b><i>'+esc(nameList(D.none))+'</i></p>';

    var plural=function(x){return x===1?unit:unit+'s'};
    return '<style>'+CSS+'</style>'
      +'<h3 class="bb-cv-h">Where we deliver</h3>'
      +'<p class="bb-cv-sub">We run our own trucks, so we only go where we have a route. Tap a '
      +unit+' to see its status.</p>'
      +'<div class="bb-cv-key">'
      +'<span><i class="bb-cv-sw" style="background:#EB673C"></i>Delivering now \u00b7 '+n.served+' '+plural(n.served)+'</span>'
      +'<span><i class="bb-cv-sw" style="background:#FDEBD9;border:1px dashed #E0A478"></i>Opening 2027 \u00b7 '+n.paused+' '+plural(n.paused)+'</span>'
      +'<span><i class="bb-cv-sw" style="background:#F1F1F1"></i>No date yet \u00b7 '+n.none+'</span>'
      +'</div>'
      +(mapSvg ? mapSvg : '<div class="bb-cv-grid" style="grid-template-columns:repeat('+grid[0].length+',var(--cv))" role="group" aria-label="Delivery coverage by '+unit+'">'+cells+'</div>')
      +'<p class="bb-cv-read" id="bb-cv-read" aria-live="polite"></p>'
      +'<div class="bb-cv-list">'+list+'</div>';
  }

  function boot(){
    var ex=document.getElementById('bb-coverage');
    /* ⭐ re-render ONCE when the outlines arrive after the lattice was already drawn */
    /* ⛔ was gated on country!=='CA', from when only the US had outlines. Canada never re-rendered
       and kept the lattice forever. One asset now carries both maps. */
    if(ex){ if((window.BB_US_MAP||window.BB_CA_MAP) && !ex.querySelector('.bb-cv-map')){ try{ex.remove();}catch(e){return;} } else return; }
    var root=document.getElementById('bb-freight-finder');if(!root)return;
    var D=window.BB_COVERAGE;
    /* ⛔ fail visible, never fatal: with no data the map simply does not appear, and the table
       above it is untouched. */
    if(!D||!D.names||!D.served)return;

    var host=document.createElement('section');
    host.id='bb-coverage';
    try{host.innerHTML=build(D)}catch(e){return}

    /* after the table's own note where there is one, otherwise straight after the table */
    var anchor=root.parentNode&&root.parentNode.nextElementSibling;
    if(anchor&&/flat rate delivery/i.test(anchor.textContent||''))anchor.parentNode.insertBefore(host,anchor.nextSibling);
    else if(root.parentNode&&root.parentNode.parentNode)root.parentNode.parentNode.insertBefore(host,root.parentNode.nextSibling);
    else root.parentNode.insertBefore(host,root.nextSibling);

    var read=document.getElementById('bb-cv-read');
    host.addEventListener('click',function(e){
      var t=e.target&&e.target.closest?e.target.closest('.bb-cv-c,.bb-cv-st'):null;
      if(t&&read)read.textContent=t.getAttribute('data-l')||'';
    });
    host.addEventListener('mouseover',function(e){
      var t=e.target&&e.target.closest?e.target.closest('.bb-cv-c,.bb-cv-st'):null;
      if(t&&read)read.textContent=t.getAttribute('data-l')||'';
    });
  }

  /* ⭐ LOAD THE MAP OUTLINES OURSELVES. Adding a <script> to page.brands.json would mean editing
     escaped HTML inside a JSON template, and a template that will not parse takes the page down.
     This asks Shopify's asset URL for the file and re-renders when it lands; if it never lands the
     tile lattice still shows, so coverage is never an empty box. */
  function loadMap(cb){
    if(window.BB_US_MAP||window.BB_CA_MAP){cb();return;}
    if(document.getElementById('bb-us-map-js')){setTimeout(cb,600);return;}
    try{
      var cur=document.querySelector('script[src*="bb-freight-finder"]');
      if(!cur){cb();return;}
      /* ⛔ KEEP THE ?v= HASH. Stripping it removed Shopify's cache key, so the CDN kept serving
         the first version of this asset and the labels never arrived. The finder's own hash changes
         whenever the finder changes, which is exactly when the map data changes too. */
      var url=cur.src.replace('bb-freight-finder.js','bb-us-coverage-map.js');
      var s=document.createElement('script');
      s.id='bb-us-map-js'; s.src=url; s.async=true;
      s.onload=function(){cb();}; s.onerror=function(){cb();};   /* fall back to the lattice */
      document.head.appendChild(s);
    }catch(e){cb();}
  }
  function bootWithMap(){ loadMap(function(){ try{boot();}catch(e){} }); }

  if(document.readyState!=='loading')bootWithMap();
  else document.addEventListener('DOMContentLoaded',bootWithMap);
  /* the finder may publish BB_COVERAGE after this runs on a slow parse */
  setTimeout(bootWithMap,400);setTimeout(bootWithMap,1500);
})();
